import React from 'react';
import {View} from 'react-native';
import {viewStyles} from 'utils';

export default function ScaffoldContainer(props) {
  const color = {backgroundColor: props.color};
  return <View style={[viewStyles.flex1, color]}>{props.children}</View>;
}
